import axios from 'common/axios.js';

export const getAccountStatus = async () => {
  try {
    let {data: {result}} = await axios.get('/v2/account/customer/profile/status');
    return result;
  } catch (e) {
    return null;
  }
};

export const getAccountInfo = async () => {
  try {
    let {data: {result}} = await axios.get('/v2/account/info');
    return result;
  } catch (e) {
    return null;
  }
};

export const getMsgList = async (params) => {
  try {
    let {data: {result}} = await axios.get('/v4/message/list', {params});
    return result;
  } catch (e) {
    return null;
  }
};

export const readMsg = async (params) => {
  try {
    let {data: {result}} = await axios.post('/v4/message/read', params, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return result;
  } catch (e) {
    return null;
  }
};

export const queryAuth = async (privilege) => {
  try {
    let {data} = await axios({
      url: '/v2/authority/privilege/query',
      method: 'get',
      params: {
        privilege
      }
    });
    return data.result;
  } catch (err) {
    console.log(err);
  }
};